import {
  IStandardAPIResponse,
  IEscalationMatrix,
  IEscalationMatrixSearch,
} from "../../vm";
import { httpClient, handleErrorResp } from "../UtilService";

export async function getAllEscalationMatrix(
  data: IEscalationMatrixSearch
): Promise<IStandardAPIResponse<Array<IEscalationMatrix>>> {
  try {
    let res = await httpClient<Array<IEscalationMatrix>>(
      `escalation-matrixes`,
      "GET",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function addEscalationMatrix(
  data: IEscalationMatrix
): Promise<IStandardAPIResponse<IEscalationMatrix>> {
  try {
    let res = await httpClient<IEscalationMatrix>(
      `escalation-matrixes`,
      "PUT",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function updateEscalationMatrix(
  data: IEscalationMatrix
): Promise<IStandardAPIResponse<IEscalationMatrix>> {
  try {
    let res = await httpClient<IEscalationMatrix>(
      `escalation-matrixes/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function deleteEscalationMatrix(
  data: IEscalationMatrix
): Promise<IStandardAPIResponse<IEscalationMatrix>> {
  try {
    let res = await httpClient<IEscalationMatrix>(
      `escalation-matrixes/${data._id}`,
      "DELETE",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
